const useEditFolioStyles = () => {
    return {
        more: {
            // position: 'absolute',
            // top: '5px',
            // right: '10px',
            // zIndex: 1000
        }
    }
}

export { useEditFolioStyles }
